import { usePermissions } from "../context/PermissionContext";

export const useCan = (screenKey) => {
    const { permissions, roleName, loading } = usePermissions();
    const roleKey = roleName ? `${roleName.toLowerCase()}.${screenKey}` : null;
    const merged = permissions?.[roleKey] || permissions?.[screenKey] || {};
    return {
        canView: !!merged.view,
        canAdd: !!merged.add,
        canEdit: !!merged.edit,
        canDelete: !!merged.delete,
        canProcess: !!merged.process,
        loading
    };
};
